import { Component, Input } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { AuthService } from '../../../auth/auth.service';
import { CatProduit } from '../../../@core/data/model/catproduit';
import { CatProduitService } from '../../../@core/data/rest/catproduit/catproduit-service';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nb-cat-select',
  templateUrl: './catselect.component.html' ,
  styles: [`
    button {
      margin: 1rem;
    }
  `],
})
export class CatSelectComponent {

  @Input() cat: CatProduit;
  @Input() parent: CatProduit;

  catSelect: CatProduit;

  selectedItems = [];
  dropdownSettings = {};

  cats: CatProduit[];

  constructor(
      protected dialogRef: NbDialogRef<CatSelectComponent>,
      public catService: CatProduitService,
      public sharedMethods: SharedMethods,
      public authService: AuthService,
      private dialogService: NbDialogService) {


  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit(): void {

    this.authService.logoutEvent.subscribe(() => {

      this.dialogRef.close();

    });

    this.cats = [];

    if ( this.parent === undefined || this.parent === null) {
  
      this.getCats();

    } else {

        this.catService.getCat(this.parent.id).then( cat => {

          this.parent = cat;

          this.catSelect = cat;

          this.cats = cat.children;

        });

    }

  }


  getCats() {
    // this.dialogIsNotShow = true;

    if (this.catService.catproduits === undefined) {

        this.catService.getCats().then( cats => {
            // si on charge toutes la liste il faut definir la variable parent à undefined
            this.parent = undefined;
            this.cats = this.parentFilter(cats);

        });

    } else {

        // si on charge toutes la liste il faut definir la variable parent à undefined
        this.parent = undefined;

        this.cats = this.parentFilter(this.catService.catproduits);
    }




  }

  parentFilter(ct: CatProduit[]): CatProduit[] {

    // recupération des parents
    const items = [];

    for ( let i = 0; i < ct.length; i++) {

      if (ct[i].parent === null) {

        items.push(ct[i]);
      }

    }

    return items;
  }

  cancel() {
    if (this.catService.iSconnecting === false) {
        this.dialogRef.close();
    }
  }

  deleteParent() {
    this.dialogRef.close(null);
  }

  getParent() {

    // alert(JSON.stringify(this.parent));
    if (this.parent !== undefined && this.parent.parent !== null ) {
      this.parent = this.parent.parent;
      this.ngOnInit();
    } else {

      if (this.parent.parent === null) {
        this.getCats();
      }

    }

  }

  select(idcat: number) {
    // alert(idcompte);
    for ( let i = 0; i < this.cats.length; i++) {

      if (this.cats[i].id === idcat) {
        this.catSelect = this.cats[i];
        // return;
      }

    }

    if (this.catSelect.children.length === 0  || (this.parent !== undefined  && this.catSelect.id === this.parent.id) ) {
      this.dialogRef.close(this.catSelect);
    } else {
      this.parent = this.catSelect;
      this.ngOnInit();
    }


  }






}
